import { SweepEvent } from '../../spline/coneSpanner/SweepEvent';
export class AxisEdgeLowPointEvent extends SweepEvent {
    constructor(edge, point) {
        super();
        this.site = point;
        this.AxisEdge = edge;
    }
    get Site() {
        return this.site;
    }
}
//# sourceMappingURL=AxisEdgeLowPointEvent.js.map